module.exports = __webpack_public_path__ + "media/src/application/media/route_4-493e302b7c9c03eb9fbd5dc6ca889af0.png";